import { useEffect, useState } from 'react';

export interface Size {
  width: number;
  height: number;
}

// Content-box size from the observer entry rather than read back off the element,
// which would force a style recalc. Null until the first observation lands.
export default function useElementSize(
  element: HTMLElement | null,
): Size | null {
  const [size, setSize] = useState<Size | null>(null);

  useEffect(() => {
    if (!element) return;

    const observer = new ResizeObserver(([entry]) => {
      const { width, height } = entry.contentRect;

      setSize((current) =>
        current?.width === width && current?.height === height
          ? current
          : { width, height },
      );
    });
    observer.observe(element);

    return () => observer.disconnect();
  }, [element]);

  return size;
}
